import React from "react";
import Modal from "react-bootstrap/Modal";
//UI
import { DangerButton, InfoButton } from "../../../../ui/buttons/Button";
import { Radio} from "../../../../ui/inputs/Input";

export default function RevisarNominas({ show, setShow, setTabla }) {
  const salir = () => {
    setShow(false);
    setTabla(0);
  };

  return (
    <Modal size="lg" show={show} centered backdrop="static" keyboard={false}>
      <Modal.Header className="col-12 m-0 px-4 py-2 d-flex justify-content-between azulGradiant text-light rounded-top azulGradiant">
        <h3 className="fw-bold m-0">Procesar Nominas</h3>
        <a type="button" className="fw-bold text-light fs-6" onClick={salir}>
          Salir <i className="fa fa-times ms-2"></i>
        </a>
      </Modal.Header>
      <Modal.Body className="col-12 m-0 p-2">
        <fieldset className="col-12 m-0 p-2 d-flex justify-content-center align-items-center gap-2 border-azul rounded">
          <legend className="m-0 w-auto float-none">Ordenar Por:</legend>
          <div className="col-auto m-0 p-0">
            <Radio label="Código" name="orden" id="orden1" />
          </div>
          <div className="col-auto m-0 p-0">
            <Radio label="Cédula" name="orden" id="orden2" />
          </div>
          <InfoButton icon = 'fa-print'>Imprimir</InfoButton> 
          <DangerButton>Cancelar</DangerButton>
        </fieldset>
      </Modal.Body>
    </Modal>
  );
}
